export default __webpack_public_path__ + "static/media/osmosis-scientist-compressed.291e0157.png";